import { render, staticRenderFns } from "./PromotionSubsetType.vue?vue&type=template&id=f044956e&"
import script from "./PromotionSubsetType.vue?vue&type=script&lang=ts&"
export * from "./PromotionSubsetType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports